import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useTableState } from "./TableStateHook";
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";

// Set the default state values for each context
export const TableStateContext = /*#__PURE__*/createContext({});
export const TableStateContextProvider = ({
  children
}) => {
  const ts = useTableState();
  const {
    stateTracker
  } = useDevLogging();
  const tableStateContext = useMemo(() => {
    stateTracker.trackState({
      tables: ts.tables
    });
    return {
      ...ts
    };
  }, [ts.tables]);
  return /*#__PURE__*/React.createElement(TableStateContext.Provider, {
    value: tableStateContext
  }, children);
};
export const useTableStateContext = () => {
  return useContext(TableStateContext);
};
TableStateContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};